<div>
  <section class="order-container" id="limitada-order">
    <div class="row">
      <div class="row">
        <div class="left">
          <div class="title-name">Títulos</div>
        </div>
        <div class="right">
          <div class="title-name">Precio</div>
        </div>
      </div>
      <div
        punchPicker
        [placeholder]="'Precio'"
        [sentValue]="selectedPrice"
        [isPrice]="true"
        (items)="setPrice($event)"
        [minValue]="0"
        data-recording-ignore="mask"
      ></div>
      <div
        punchPicker
        [sentValue]="titles"
        [placeholder]="'Títulos'"
        [isTitles]="true"
        (items)="setTitles($event)"
        data-recording-ignore="mask"
      ></div>
    </div>
    <div class="row">
      <div class="row">
        <div class="left">
          <div class="title-name">Duración</div>
        </div>
      </div>
      <combo-select
        *ngIf="canModifyDuration === true"
        class="duration"
        [sentSelected]="defaultDuration"
        [resultsList]="vigencia"
        [title]="'Duración'"
        (emitSelectedItem)="setDuration($event)"
      >
      </combo-select>
      <div class="hard-section" *ngIf="canModifyDuration === false">
        <div class="subtitle">1 día</div>
      </div>
    </div>
    <div class="actions" *ngIf="canOperate && !isDiscretional">
      <button (click)="tryBuy()" class="btn-compra">
        <div class="button button--loading" *ngIf="isBuyButtonLoading">
          <div class="button__loader">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        {{ isBuyButtonLoading ? '' : 'Comprar' }}
      </button>
      <button (click)="trySell()" class="btn-venta">
        <div class="button button--loading" *ngIf="isSellButtonLoading">
          <div class="button__loader">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        {{ isSellButtonLoading ? '' : 'Vender' }}
      </button>
    </div>
  </section>
  <app-confirmation-modal
    [order]="confirmationOrder"
    (onClose)="cancelConfirmation()"
    (confirmationHandler)="registerOrder()"
    *ngIf="showConfirmation"
  >
  </app-confirmation-modal>
</div>
